import EventEmitter from 'events'

import store from '@/store/store.js'

const localStorageKey = 'loggedIn'
const tokenExpiryKey = 'exp'
const loginEvent = 'loginEvent'

class AuthService extends EventEmitter {
    idToken = null;
    profile = null;
    tokenExpiry = null;

    localLogin (authResult) {
      this.idToken = authResult.idToken
      this.profile = authResult.idTokenPayload
      this.tokenExpiry = new Date(this.profile.exp * 1000)
      localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
      localStorage.setItem(localStorageKey, 'true')

      store.commit('UPDATE_USER_INFO', {
        displayName: this.profile.name,
        email: this.profile.email,
        photoURL: this.profile.picture,
        providerId: this.profile.sub.substr(0, this.profile.sub.indexOf('|')),
        uid: this.profile.sub
      })
      this.emit(loginEvent, {
        loggedIn: true,
        profile: authResult.idTokenPayload,
        state: authResult.appState || {}
      })
    }

    logOut () {
      localStorage.removeItem(localStorageKey)
      localStorage.removeItem(tokenExpiryKey)
      localStorage.removeItem('userInfo')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('exp')
      this.idToken = null
      this.tokenExpiry = null
      this.profile = null
      this.emit(loginEvent, { loggedIn: false })
    }

    isAuthenticated () {
      return (
        new Date(Date.now()) < new Date(parseInt(localStorage.getItem(tokenExpiryKey)))
      )
    }
}

export default new AuthService()
